'use strict';

/* global $ */

import { breakpoints } from '../settings'
import { getAjax } from '../utils/ajax';

function ajaxVisSlider(options) {

    let settings = {
        blockSelector: '.js-vis-slider__block',
        sliderSelector: '.js-vis-slider',
        arrowsSelector: '.js-vis-slider__arrows',
    };

    let opt = $.extend({}, settings, options);
    let slider = opt.sliderSelector,
        block = opt.blockSelector,
        arrows = opt.arrowsSelector;

    $(slider).each(function() {
        getPhotos(this); 
    });

    function getPhotos(item) {

    	let data = $.extend({}, $('body').data());
	    getAjax('get_photos', data).then(function(data) {
	        if (data.ok) {
	            $(item).html(data.content);
	            initSlider(item);
	        } else {
	            console.error('Can\'t get photos');
	        }
	    }).catch(function(error) {
	        throw new Error(error);
	    });
    }

    function initSlider(item) {
    	let $slider = $(item).find(block),
    		$arrows = $(item).find(arrows);

		console.log($slider);

    	if ($slider.length > 0) {
		    $slider.not('.slick-initialized').slick({
		        slidesToShow: 2,
		        slidesToScroll: 1,
		        arrows: true,
		        swipeToSlide: true,
		        speed: 500,
		        easing: 'easeInOutQuart',
		        accessibility: false,
		        infinite: false,
		        appendArrows: $arrows,
				prevArrow: '<a class="land-branch__arrows-arrow m--prev slick-prev"></a>',
				nextArrow: '<a class="land-branch__arrows-arrow m--next slick-next"></a>',
		        responsive: [          
		            {
		                breakpoint: breakpoints.xs,
		                settings: {
		                    slidesToShow: 1,
		                    slidesToScroll: 1
		                }
		            },                     
		        ]

		    });
    	}
    }
}

export {
    ajaxVisSlider
};